import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { tfAlw, tfAlwList } from "./data";

export default function TaxFreeAllowance(props) {
  const { payrollSEQ } = props;

  const [dataSource, setDataSource] = useState(null);
  const [tfAlwDataSource, setTFAlwDataSource] = useState(
    new DataSource({
      store: tfAlwList,
      type: "array",
      key: "id",
    })
  );

  const userInfo = useSelector((state) => state.userInfo);

  const taxFreeAllowanceGridRef = useRef(null);

  useEffect(() => {
    // setTFAlwDataSource(
    //   new DataSource({
    //     store: tfAlwList,
    //     type: "array",
    //     key: "id",
    //   })
    // );

    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/tfAlw/${userInfo.employeeNo}/${payrollSEQ}`
          );

          return result.data;
        },
        insert: async (values) => {
          values = {
            ...values,
            otrTfAlw:
              values.tfAlw == "9"
                ? tfAlwDataSource.items().find((item) => item.id == "9").name
                : null,
          };

          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/tfAlw/${userInfo.employeeNo}/${payrollSEQ}`,
            values
          );
        },
        update: async (key, values) => {
          values = {
            ...values,
            otrTfAlw:
              values.tfAlw == "9"
                ? tfAlwDataSource.items().find((item) => item.id == "9").name
                : null,
          };

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/tfAlw/${userInfo.employeeNo}/${payrollSEQ}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/salaryInfo/tfAlw/${userInfo.employeeNo}/${payrollSEQ}/${key}`
          );
        },
      })
    );
  }, []);

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const newTFAlw = {
      id: "9",
      name: args.text,
    };

    args.customItem = tfAlwDataSource
      .store()
      .insert(newTFAlw)
      .then(() => tfAlwDataSource.load())
      .then(() => newTFAlw)
      .catch((error) => {
        throw error;
      });
  };

  const displayExpr = (item) => {
    if (item) {
      if (item == "9" || item.id == "9") {
        let gridInstance = taxFreeAllowanceGridRef.current.instance;
        let editRowKey = gridInstance.option("editing.editRowKey");
        let index = gridInstance.getRowIndexByKey(editRowKey);
        index = index === -1 ? 0 : index;

        if (gridInstance.cellValue(index, "otrTfAlw")) {
          return gridInstance.cellValue(index, "otrTfAlw");
        } else {
          return item.name;
        }

        // return gridInstance.cellValue(index, "otrTfAlw");
      } else {
        return item.name;
      }
    }
  };

  const calculateDisplayValue = (data) => {
    if (data.tfAlw != "9") {
      return tfAlw[data.tfAlw];
    } else {
      return data.otrTfAlw;
    }
  };

  const onInitNewRow = (e) => {
    const key = taxFreeAllowanceGridRef.current.instance.getKeyByRowIndex(0);

    if (key) {
      e.component.selectRows(key, true);
      e.data =
        taxFreeAllowanceGridRef.current.instance.getSelectedRowsData()[0];
    }
  };

  return (
    <DataGrid
      id="taxFreeAllowanceGrid"
      ref={taxFreeAllowanceGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onInitNewRow={onInitNewRow}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Tax-Free Allowance"}
          confirmDeleteMessage={
            "Are you sure you want to delete this tax-free allowance?"
          }
        />
        <Popup title={"Tax-Free Allowance"} showTitle={true} height={200} />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="taxFreeAllowance"
          height={"100%"}
        >
          <SimpleItem
            dataField={"tfAlw"}
            editorType="dxSelectBox"
            editorOptions={{
              dataSource: tfAlwDataSource,
              valueExpr: "id",
              // displayExpr: "name",
              displayExpr: displayExpr,
              showClearButton: true,
              placeholder: "직접입력가능",
              acceptCustomValue: true,
              onCustomItemCreating: onCustomItemCreating,
            }}
          >
            <Label text={"항목"} />
          </SimpleItem>
          <SimpleItem
            dataField={"amt"}
            editorType="dxNumberBox"
            editorOptions={{
              showClearButton: true,
              format: "#0원",
            }}
          >
            <Label text={"금액"} />
          </SimpleItem>
        </Form>
      </Editing>

      <Column
        dataField={"tfAlw"}
        caption="항목"
        calculateDisplayValue={calculateDisplayValue}
      >
        {/* <Lookup dataSource={tfAlwList} valueExpr="id" displayExpr={"name"} /> */}
      </Column>
      <Column dataField={"otrTfAlw"} caption="기타 항목" visible={false} />
      <Column
        dataField={"amt"}
        caption="금액"
        dataType={"number"}
        format={"#,##0원"}
      />
    </DataGrid>
  );
}
